import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { View, Text, ActivityIndicator } from 'react-native';
import { ActivityLookupTable } from '../hooks/ActivityLookupTable';
import { insertActivityLog, updateActivityLog } from '../reducers/cbcActivityActionsSlice.js';
import { setCurrentWorkout, setCurrentWorkoutActivity, fetchLatestWorkout } from '../reducers/cbcWorkoutSlice';
import ActivityStartScreen from './ActivityStartScreen';
import ThirdPartyGameView from './ThirdPartyGameView';
import styled from 'styled-components/native';
import { StackActions, CommonActions } from '@react-navigation/native';
import DynamicModal from "../modals/DynamicModal";

function ActivityContainer(props) {
    const dispatch = useDispatch();

    const paramsPath = props.route.params;
    const CurrentActivityComponent = ActivityLookupTable[paramsPath.activityName].component;
    const HasScoring = ActivityLookupTable[paramsPath.activityName].hasScoring;
    const IsWebGame = ActivityLookupTable[paramsPath.activityName].webGame;
    const CurrentActivityURL = ActivityLookupTable[paramsPath.activityName].gameUrl;
    const scoringSettings = ActivityLookupTable[paramsPath.activityName].scoringSettings;
    const startScreenProps = ActivityLookupTable[paramsPath.activityName].startScreenProps;

    const [hasActivityStarted, setHasActivityStarted] = useState(false);
    const [isActivityOver, setIsActivityOver] = useState(false);
    const [isWorkout, setIsWorkout] = useState(false);
    const [isLastExercise, setIsLastExercise] = useState(0);
    const [modalCallback, setModalCallback] = useState(null);
    const [currentModalMessaging, setCurrentModalMessaging] = useState(null);

    const { insertActivityLogResultsMsg, updateActivityLogResultsMsg, activity_modal_messaging } = useSelector((state) => state.activityActions);
    const { loading_msg } = useSelector((state) => state.activityActions);
    const { current_workout, current_workout_activity } = useSelector((state) => state.cbcWorkout);

    const { activity_log_id } = useSelector((state) => state.activityActions);

    useEffect(() => {
        if (paramsPath.workoutId > 0) {
            setIsWorkout(true);
        }
    }, [paramsPath.workoutId]);

    useEffect(() => {
        setCurrentModalMessaging(activity_modal_messaging);
    }, [activity_modal_messaging]);

    const insertLogObject = {
        activity_id: parseInt(paramsPath.activityId),
        current_user_id: parseInt(paramsPath.userId),
        game_type: paramsPath.gameType,
        assessment_log_id: null,
        workout_id: paramsPath.workoutId
    };

    const updateLogObject = {
        activity_id: parseInt(paramsPath.activityId),
        current_user_id: parseInt(paramsPath.userId),
        activity_type: paramsPath.gameType,
        assessment_log_id: null,
        activity_log_id: null,
        completed: null,
        result_breakdown: null,
        scoring: scoringSettings.scoring ? scoringSettings.scoring : null,
        total_rounds: scoringSettings.total_rounds ? scoringSettings.total_rounds : null,
        score_multiplier: scoringSettings.score_multiplier ? scoringSettings.score_multiplier : null,
        score_increment: scoringSettings.score_increment ? scoringSettings.score_increment : null,
    };

    // Callback function for when the game start button is triggered
    function startButtonCallback() {
        startGame();
    }

    // Dispatches the action for inserting the activity log.
    // This is essentially starting the game.
    // when this returns successful, we catch it and then allow the actual game component to run.
    function startGame() {
        dispatch(insertActivityLog(insertLogObject)).then(function () {
            setHasActivityStarted(true);
        });
    }

    function endGameCallback(params) {
        setIsActivityOver(true);
        updateLogObject.activity_log_id = activity_log_id;
        updateLogObject.completed = params['completed'];
        endGame();
    }

    async function endGame() {
        console.log('endGame called');
        if (paramsPath.workoutId > 0 && isLastExercise === 0 && (current_workout_activity.type != 'free_choice' && current_workout_activity.name != "Free Choice")) {
            try {
                dispatch(updateActivityLog(updateLogObject)).then(function (response) {
                    if (typeof response.payload.react_modal_messaging === "object" && response.payload.react_modal_messaging !== null) {
                        setModalCallback(() => continueWorkout);
                    } else {
                        console.log('activity_modal_messaging', response.payload.react_modal_messaging, typeof response.payload.react_modal_messaging);
                        continueWorkout();
                    }
                });
            } catch (error) {
                console.error('Failed to end game: ', error);
            }
        } else {
            try {
                dispatch(updateActivityLog(updateLogObject)).then(function (response) {
                    if (typeof response.payload.react_modal_messaging === "object" && response.payload.react_modal_messaging !== null) {
                        setModalCallback(() => endWorkout);
                    } else {
                        console.log('activity_modal_messaging', response.payload.react_modal_messaging, typeof response.payload.react_modal_messaging);
                        console.log('hello?');
                        endWorkout();
                    }
                });
            } catch (error) {
                console.error('Failed to end game: ', error);
            }
        }
        return;
    }

    function continueWorkout() {
        setTimeout(function () {
            console.log('continueWorkout call');
            dispatch(fetchLatestWorkout({})).then(function () {
                props.navigation.dispatch(StackActions.replace('continueworkout'));
            });
        }, 500);
    }

    function endWorkout() {
        console.log('endWorkout call');
        props.navigation.dispatch(
            CommonActions.reset({
                index: 0,
                routes: [{ name: 'dashboard' }],
            })
        );
    }

    useEffect(() => {
        // This function will run when the component is unmounted, resetting the states to their initial values
        return () => {
            setHasActivityStarted(false);
            setIsActivityOver(false);
        };
    }, []);

    function renderActivityContent() {
        return (
            <>
                <DynamicModal callback={modalCallback} />
                {loading_msg !== 'idle' || isActivityOver ? (
                    <View style={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                        <ActivityIndicator size="large" />
                    </View>
                ) : (
                    !hasActivityStarted && !isActivityOver ? (
                        <ActivityStartScreen
                            style={{ width: '100%', height: "100%" }}
                            startScreenProps={startScreenProps}
                            startButtonCallback={startButtonCallback}
                        />
                    ) : (
                        HasScoring == 1 ? (
                            <CurrentActivityComponent
                                style={{ width: '100%', height: "100%" }}
                                endGameCallback={endGameCallback}
                                isWorkout={isWorkout}
                            />
                        ) : (
                            IsWebGame == 0 ? (
                                <CurrentActivityComponent
                                    style={{ width: '100%', height: "100%" }}
                                    endGameCallback={endGameCallback}
                                    isWorkout={isWorkout}
                                />
                            ) : (
                                <ThirdPartyGameView
                                    style={{ width: '100%', height: "100%" }}
                                    gameUrl={CurrentActivityURL}
                                    endGameCallback={endGameCallback}
                                />
                            )
                        )
                    )
                )}
            </>
        );
    }

    useEffect(() => {
        //Determine if last exercise in workout.
        const exerciseIndex = current_workout.activities.indexOf(current_workout_activity);
        if (exerciseIndex === (current_workout.activities.length - 1)) {
            setIsLastExercise(1);
        }
        console.log('exerciseIndex:', exerciseIndex, 'isLastExercise:', isLastExercise);
    });

    return (
        <ActivityContainerParent>
            {renderActivityContent()}
        </ActivityContainerParent>
    );
}

export const ActivityContainerParent = styled.View`
  width: 100%;
  height: 100%;
`;

export default ActivityContainer;
